import React from 'react';
import {colors} from 'styles/shared';

function Icon(props) {
  let backgroundColor = props.disabled ? colors.darkBlue_lighter : colors.blue_light;

  let color = props.disabled ? colors.darkBlue_light : colors.blue_darker;

  return (
    <svg width="70" height="70" fill="none" viewBox="0 0 70 70">
      <rect width="70" height="70" fill={backgroundColor} rx="35"></rect>
      <path
        fill={color}
        d="M52.373 32.415l-15.998-13.09a1.454 1.454 0 00-1.847 0L18.53 32.416a1.457 1.457 0 101.847 2.255l1.985-1.63v13.592a4.363 4.363 0 004.363 4.363h17.453a4.364 4.364 0 004.363-4.363V33.04l1.985 1.629c.26.212.587.328.924.327a1.454 1.454 0 00.923-2.582zm-19.83 15.671v-7.272a1.454 1.454 0 011.454-1.454h2.909a1.454 1.454 0 011.454 1.454v7.272h-5.817zm13.09-1.454a1.455 1.455 0 01-1.455 1.454h-2.909v-7.272a4.363 4.363 0 00-4.363-4.363h-2.909a4.363 4.363 0 00-4.363 4.363v7.272h-2.909a1.455 1.455 0 01-1.454-1.454V30.634l10.18-8.305 10.181 8.305v15.998z"></path>
    </svg>
  );
}

export default Icon;
